// extracted by mini-css-extract-plugin
export default {"forMore":"LoginFooter_forMore__BuXjf","iconPhone":"LoginFooter_iconPhone__86fx4","phoneNumber":"LoginFooter_phoneNumber__N+KVe"};